export const nameOf = <T>(key: keyof T & string): string => key;
